// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a44773f7","703":"aebb34cd"}[chunkId] + ".chunk.js";
};